module.exports = __webpack_public_path__ + "img/redis-list.fd415b03.svg";